import React, { useEffect, useState } from "react";
import { api, publicAssetUrl } from "@/lib/api";
import { buildSearchUrl } from "@/lib/partnerBrands";
import { trackEvent } from "@/lib/analytics";
import { ExternalLink } from "lucide-react";

const DEFAULT_SLUGS = ["amazon", "flipkart", "myntra", "ajio", "swiggy"];

/**
 * "Also try on other stores" strip — appears at the bottom of /posts search
 * results whenever the query is non-empty. Deep-links into each partner
 * search page with the query and, if configured, the affiliate id.
 */
export function SmartSearchPartnerStrip({ query, slugs = DEFAULT_SLUGS }) {
    const [brands, setBrands] = useState([]);
    useEffect(() => {
        api.get("/partner-brands").then((r) => {
            const items = Array.isArray(r.data) ? r.data : (r.data.items || []);
            const byslug = Object.fromEntries(items.map((b) => [b.slug, b]));
            setBrands(slugs.map((s) => byslug[s]).filter((b) => b && b.is_active !== false && b.search_url_template));
        }).catch(() => setBrands([]));
    }, [slugs]);

    if (!query || !query.trim() || brands.length === 0) return null;

    const onClick = (b) => {
        trackEvent("search_submit", { source: "smart_search_partner", query, partner: b.slug });
        const url = buildSearchUrl(b, query);
        if (url && url !== "#") window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <section className="mt-6" data-testid="smart-search-partner-strip">
            <div className="mb-2 font-heading text-sm font-bold text-[var(--text-primary)]">
                Also try on other stores
            </div>
            <div className="flex flex-wrap gap-2">
                {brands.map((b) => (
                    <button
                        key={b.slug}
                        onClick={() => onClick(b)}
                        data-testid={`find-on-${b.slug}-btn`}
                        className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 font-heading text-sm font-semibold text-[var(--text-primary)] transition hover:border-[var(--brand-orange)] hover:bg-[#FFF8F2]"
                        style={{ borderColor: b.brand_color ? `${b.brand_color}55` : undefined }}
                    >
                        {b.logo_url && (
                            <img src={publicAssetUrl(b.logo_url)} alt="" className="h-4 w-4 object-contain" onError={(e) => { e.target.style.display = "none"; }} />
                        )}
                        Find on {b.name}
                        <ExternalLink size={11} className="opacity-60" />
                    </button>
                ))}
            </div>
        </section>
    );
}

export default SmartSearchPartnerStrip;
